var _a;
/**
 * TextOtpCountry Enumeration
 */
import { CountryEnum } from "./CountryEnum";
var TextOtpCountryEnum;
(function (TextOtpCountryEnum) {
    TextOtpCountryEnum["CO"] = "KUSHKI VERIFICACION";
    TextOtpCountryEnum["EC"] = "HELP_KUSHKI VERIFICACI\u00D3N";
    TextOtpCountryEnum["MX"] = "BP*KS*VERIFICACION";
    TextOtpCountryEnum["PE"] = "KSK*VERIFICACION PE";
    TextOtpCountryEnum["CL"] = "VERIFICACION KS";
})(TextOtpCountryEnum || (TextOtpCountryEnum = {}));
var TextOtpByCountry = (_a = {},
    _a[CountryEnum.CO] = TextOtpCountryEnum.CO,
    _a[CountryEnum.EC] = TextOtpCountryEnum.EC,
    _a[CountryEnum.MX] = TextOtpCountryEnum.MX,
    _a[CountryEnum.PE] = TextOtpCountryEnum.PE,
    _a[CountryEnum.CL] = TextOtpCountryEnum.CL,
    _a.default = TextOtpCountryEnum.EC,
    _a);
export var getTextByCountry = function (country) {
    return TextOtpByCountry[country] || TextOtpByCountry["default"];
};
